import { IGetAllEntregaObraUseCase } from "../../../presentation/useCases/read/get_all_entrega_obra_use_case";
import { BasePaginatedUseCase } from "../../../../../common/domain/useCases/base_paginated_use_case";
import { IEntregaObrasRepository } from "../../repositories/entrega_obras_repositories";
import { EntregaObrasListaModel } from "../../models/entrega_obras_lista";

/**
 * GetAllEntregaObraUseCase
 */

export class GetAllEntregaObraUseCase extends BasePaginatedUseCase<EntregaObrasListaModel> implements IGetAllEntregaObraUseCase {
  constructor(private readonly repository: IEntregaObrasRepository) {
    super();
  }
  async execute(
    idsCentroCusto?: number[],
    status?: number,

    currentPage?: number,
    rowsPerPage?: number): Promise<void> {
    const result = await this.repository.getAllEntregaObra(idsCentroCusto, status, currentPage, rowsPerPage);

    this._items = result.items;
    this._totalItems = result.totalItems;
    this._totalPages = result.totalPages;
    this._currentPage = result.currentPage;
    this._pageSize = result.pageSize;

  }
}
